module.exports = __webpack_public_path__ + "static/media/map-cluster-512.d520fd16.png";